const common = {};

const env = {
  development: {
    AUTH0_DOMAIN: 'lease-manager-dev.us.auth0.com',
    AUTH0_CLIENTID: 'Sc7miWM8HaLaS6LRNllVkx7Egjj4Y7xJ',
    AUTH0_AUDIENCE: 'https://lease-manager.com/',
    API_URI: 'http://localhost:3000/api/graphql',
  },
  test: {
    AUTH0_DOMAIN: 'lease-manager-dev.us.auth0.com',
    AUTH0_CLIENTID: 'Sc7miWM8HaLaS6LRNllVkx7Egjj4Y7xJ',
    AUTH0_AUDIENCE: 'https://lease-manager.com/',
    API_URI: 'http://localhost:3000/api/graphql',
  },
  production: {
    AUTH0_DOMAIN: 'lease-manager.us.auth0.com',
    AUTH0_CLIENTID: 'vrygGhJLk1P1flhtqK1MmqlPxBTiIs1k',
    AUTH0_AUDIENCE: 'https://lease-manager.com/',
    API_URI: 'https://app.mysuitebeautysquare.net/api/graphql',
  },
};

export default {
  ...common,
  ...env[process.env.REACT_APP_STAGE],
};
